module.exports = __webpack_public_path__ + "static/RV-cf2a4e3e9f51d7531820ce7ef6114342.jpg";